import instance from "./Instance/index.js";

export const createTest = async (values) => {
  try {
    const response = await instance.post(`/tests`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getTest = async (id) => {
  try {
    const response = await instance.get(`/tests/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getTests = async () => {
  try {
    const response = await instance.get(`/tests`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUsersTests = async () => {
  try {
    const response = await instance.get(`/tests/users/tests`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteTest = async (id) => {
  try {
    const response = await instance.delete(`/tests/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
